import PriceInterval from "./PriceInterval";
export default PriceInterval;
